// extracted by mini-css-extract-plugin
export default {"Box":"potentially-dirty-module__Box--W21vX","PotentiallyDirty":"potentially-dirty-module__PotentiallyDirty--dt01t","hasChildren":"potentially-dirty-module__hasChildren--LeHND"};